export type AnalyticsEventName = 'estimator_started' | 'estimate_generated' | 'lead_form_viewed' | 'lead_submitted' | 'provider_value_viewed' | 'demo_data_cleared';
export interface AnalyticsEvent { id: string; name: AnalyticsEventName; at: string; payload: Record<string, string | number | boolean | null>; }

const KEY = 'reformas_leads_analytics_v1';
const PII = new Set(['name', 'email', 'phone', 'notes', 'postalCode']);

export function trackEvent(name: AnalyticsEventName, payload: Record<string, unknown> = {}): AnalyticsEvent {
  const event = { id: id(), name, at: new Date().toISOString(), payload: stripPii(payload) };
  const events = getAnalyticsEvents();
  events.push(event);
  safeSet(KEY, JSON.stringify(events.slice(-200)));
  return event;
}

export function getAnalyticsEvents(): AnalyticsEvent[] {
  const raw = safeGet(KEY);
  if (!raw) return [];
  try { const parsed = JSON.parse(raw) as AnalyticsEvent[]; return Array.isArray(parsed) ? parsed : []; }
  catch { return []; }
}

export function clearAnalyticsEvents(): void { safeSet(KEY, '[]'); }

export function stripPii(payload: Record<string, unknown>): AnalyticsEvent['payload'] {
  return Object.fromEntries(Object.entries(payload).filter(([k]) => !PII.has(k)).map(([k, v]) => [k, clean(v)]));
}

function clean(v: unknown): string | number | boolean | null {
  return typeof v === 'string' || typeof v === 'number' || typeof v === 'boolean' ? v : null;
}
function id(): string { return globalThis.crypto?.randomUUID?.() ?? `event-${Date.now()}-${Math.random().toString(16).slice(2)}`; }
function safeGet(k: string): string | null { try { return globalThis.localStorage?.getItem(k) ?? null; } catch { return null; } }
function safeSet(k: string, v: string): void { try { globalThis.localStorage?.setItem(k, v); } catch { /* never break funnel */ } }
